// extracted by mini-css-extract-plugin
export default {"searchForm":"style_searchForm__oE9tP","hidden":"style_hidden__l2GSR"};